/* Créée par Incipit Studio — panier Shopify, compatible avec les formulaires Dawn et KAARZ. */
(() => {
  if (customElements.get('cart-drawer')) return;
  class KaarzCart extends HTMLElement {
    connectedCallback() {
      if (!this.classList.contains('kc-root')) return;
      this.controller = new AbortController();
      this.jobs = Promise.resolve(); this.revision = 0;
      this.dialog = this.querySelector('dialog');
      this.panel = this.querySelector('.kc-panel');
      this.sectionId = this.dataset.sectionId;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const opts = { signal: this.controller.signal };
      this.addEventListener('click', event => this.onClick(event), opts);
      this.addEventListener('change', event => this.onChange(event), opts);
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, opts);
      this.dialog.addEventListener('close', () => this.restoreScroll(), opts);
      document.addEventListener('click', event => {
        const link = event.target.closest('#cart-icon-bubble, [data-kaarz-cart-open]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); this.open(link); this.refresh();
      }, opts);
      document.addEventListener('keydown', event => {
        if (event.key === ' ' && event.target.matches('#cart-icon-bubble, [data-kaarz-cart-open]')) {
          event.preventDefault(); this.open(event.target); this.refresh();
        }
      }, opts);
      document.addEventListener('kaarz:cart:refresh', () => this.refresh(), opts);
      window.addEventListener('pageshow', event => { if (event.persisted) this.refresh(); }, opts);
      this.bindPubsub();
      document.addEventListener('DOMContentLoaded', () => { this.bindPubsub(); this.syncCount(); }, opts);
      document.addEventListener('shopify:section:load', () => this.syncCount(), opts);
      document.addEventListener('shopify:section:select', event => {
        if (event.detail.sectionId === this.sectionId) this.open();
      }, opts);
      document.addEventListener('shopify:section:deselect', event => {
        if (event.detail.sectionId === this.sectionId) this.close();
      }, opts);
      this.syncCount();
      // Interface partagée avec les futures pages produit et leurs sélections de plusieurs sprays.
      this.api = {
        add: (items, trigger) => { this.setActiveElement(trigger); return this.mutate('add', { items }, true); },
        open: trigger => { this.open(trigger); return this.refresh(); },
        refresh: () => this.refresh()
      };
      window.KaarzCart = this.api;
    }
    disconnectedCallback() {
      this.controller?.abort(); this.unsubscribe?.(); this.requestController?.abort();
      clearTimeout(this.closeTimer); clearTimeout(this.refreshTimer);
      if (this.dialog?.open) this.dialog.close();
      this.restoreScroll();
      if (window.KaarzCart === this.api) delete window.KaarzCart;
    }
    bindPubsub() {
      if (this.unsubscribe || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
        if (event.source !== 'kaarz-cart') this.scheduleRefresh();
      });
    }
    scheduleRefresh() {
      ++this.revision;
      clearTimeout(this.refreshTimer);
      this.refreshTimer = setTimeout(() => this.refresh(), 60);
    }
    getSectionsToRender() { return [{ id: this.sectionId, selector: '[data-kc-content]' }]; }
    setActiveElement(element) { if (element instanceof HTMLElement) this.activeElement = element; }
    renderContents() {
      // Une réponse cart/add peut être dépassée par un autre ajout. Relire le panier courant.
      this.open(this.activeElement); this.scheduleRefresh();
    }
    open(trigger) {
      this.setActiveElement(trigger);
      clearTimeout(this.closeTimer);
      document.querySelectorAll('kaarz-header').forEach(header => {
        header.closeMenu?.(); if (header.dialog?.open) header.closeMobile?.(false);
      });
      if (!this.dialog.open) {
        this.activeElement ||= document.activeElement;
        const body = document.body;
        this.scrollState = { y: window.scrollY, position: body.style.position, top: body.style.top, width: body.style.width, overflow: body.style.overflow, paddingRight: body.style.paddingRight };
        const gap = window.innerWidth - document.documentElement.clientWidth;
        const padding = parseFloat(getComputedStyle(body).paddingRight) || 0;
        Object.assign(body.style, { position: 'fixed', top: `-${this.scrollState.y}px`, width: '100%', overflow: 'hidden', paddingRight: `${padding + Math.max(0,gap)}px` });
        this.dialog.showModal();
        this.panel.focus({ preventScroll: true });
        // Le focus natif peut suivre le panneau encore hors champ à l'ouverture.
        // overflow:clip empêche ce déplacement ; remise à zéro pour le repli hidden.
        this.dialog.scrollLeft = 0;
        this.dialog.scrollTop = 0;
        // Valider le premier état avant la transition d’entrée.
        this.dialog.getBoundingClientRect();
      }
      this.dialog.classList.add('is-open');
      document.querySelectorAll('#cart-icon-bubble, [data-kaarz-cart-open]').forEach(link => link.setAttribute('aria-expanded', 'true'));
    }
    close() {
      if (!this.dialog.open) return;
      this.dialog.classList.remove('is-open');
      document.querySelectorAll('#cart-icon-bubble, [data-kaarz-cart-open]').forEach(link => link.setAttribute('aria-expanded', 'false'));
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => {
        this.dialog.close(); this.restoreScroll();
        if (this.activeElement?.isConnected) this.activeElement.focus({ preventScroll: true });
      }, this.reduced.matches ? 0 : 330);
    }
    restoreScroll() {
      if (!this.scrollState) return;
      const { y, ...styles } = this.scrollState; this.scrollState = null;
      Object.assign(document.body.style, styles);
      window.scrollTo({ top: y, behavior: 'instant' });
    }
    syncCount() {
      const content = this.querySelector('[data-kc-content]'); if (!content) return;
      const count = Number(content.dataset.count) || 0;
      document.documentElement.dataset.kcCount = String(count);
      this.classList.toggle('is-empty', count === 0);
      document.querySelectorAll('#cart-icon-bubble, [data-kaarz-cart-open]').forEach(link => {
        link.setAttribute('aria-label', `Panier — ${count} article${count > 1 ? 's' : ''}`);
        link.setAttribute('aria-haspopup', 'dialog'); link.setAttribute('aria-expanded', String(this.dialog.open));
        const sr = link.querySelector('.kn-sr'); if (sr) sr.textContent = link.getAttribute('aria-label');
        const bubble = link.querySelector('.cart-count-bubble');
        if (bubble) { bubble.hidden = count === 0; const text = bubble.querySelector('[aria-hidden]'); if (text) text.textContent = String(count); }
      });
    }
    onClick(event) {
      if (event.target.closest('[data-kc-close]')) { this.close(); return; }
      if (event.target.closest('[data-kc-retry]')) { this.refresh(); return; }
      const remove = event.target.closest('[data-kc-remove]');
      const add = event.target.closest('[data-kc-add]');
      if (this.busy || this.recoveryRequired) return;
      if (remove) this.mutate('change', { id: remove.dataset.key, quantity: 0 });
      if (add) this.mutate('add', { items: [{ id: Number(add.dataset.kcAdd), quantity: 1 }] });
    }
    onChange(event) {
      const select = event.target.closest('[data-kc-quantity]');
      const input = event.target.closest('[data-kc-custom]');
      if (!select && !input || this.busy || this.recoveryRequired) return;
      if (select?.value === 'other') {
        select.parentElement.hidden = true;
        const custom = select.closest('.kc-line-actions').querySelector('[data-kc-custom]');
        custom.hidden = false; custom.focus(); custom.select(); return;
      }
      const field = select || input;
      const quantity = Number(field.value);
      const minimum = Number(select?.dataset.min || input?.min || 1);
      const step = Number(select?.dataset.step || input?.step || 1);
      const maximum = select?.dataset.max || input?.max;
      if (!Number.isInteger(quantity) || quantity < minimum || (quantity - minimum) % step || maximum && quantity > Number(maximum)) {
        this.showError('Cette quantité n’est pas disponible. Choisissez une quantité autorisée.');
        if (input) { input.value = input.defaultValue; input.focus(); }
        return;
      }
      this.mutate('change', { id: field.dataset.key, quantity });
    }
    setBusy(value) {
      this.busy = value;
      const content = this.querySelector('[data-kc-content]');
      content.inert = value || !!this.recoveryRequired;
      content.setAttribute('aria-busy', String(value));
    }
    showError(message) {
      this.querySelector('[data-kc-error]').textContent = message;
      this.querySelector('.kc-error').hidden = false;
    }
    async request(url, options = {}) {
      const controller = this.requestController = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(url, { credentials: 'same-origin', ...options, signal: controller.signal });
        const payload = options.method ? await response.json() : await response.text();
        if (!response.ok || options.method && payload.status) {
          const error = new Error(payload.description || 'Le panier n’a pas pu être actualisé.');
          error.confirmed = response.status >= 400 && response.status < 500;
          throw error;
        }
        return payload;
      } finally { clearTimeout(timeout); }
    }
    endpoint(name) {
      const route = name === 'add' ? this.dataset.addUrl : this.dataset.changeUrl;
      return route.endsWith('.js') ? route : `${route}.js`;
    }
    captureFocus() {
      const active = document.activeElement;
      const line = active?.closest('[data-line-key]');
      return { key: line?.dataset.lineKey, quantity: !!active?.matches('[data-kc-quantity], [data-kc-custom]'), inside: this.contains(active) };
    }
    applyHTML(html, focus = this.captureFocus()) {
      if (typeof html !== 'string') throw new Error('Section du panier absente.');
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('[data-kc-content]');
      if (!next || !next.hasAttribute('data-count')) throw new Error('Réponse du panier incomplète.');
      const scroll = this.querySelector('[data-kc-scroll]').scrollTop;
      const content = this.querySelector('[data-kc-content]');
      content.replaceChildren(...next.childNodes);
      for (const key of ['count', 'sprayCount', 'total']) content.dataset[key] = next.dataset[key];
      this.querySelector('[data-kc-scroll]').scrollTop = scroll;
      this.recoveryRequired = false;
      this.syncCount();
      // Les montants et l’éligibilité affichés sont ceux du rendu serveur Shopify.
      const node = this.querySelector('.kc-progress span');
      if (node && !this.reduced.matches && this.progressWidth != null) {
        node.animate([{ width: this.progressWidth }, { width: node.style.width }], { duration: 250, easing: 'ease' });
      }
      this.progressWidth = node?.style.width;
      this.setBusy(this.busy);
      if (focus.inside && this.dialog.open && !this.busy) this.restoreFocus(focus);
    }
    restoreFocus(focus) {
      if (!focus?.inside || !this.dialog.open) return;
      const row = [...this.querySelectorAll('[data-line-key]')].find(el => el.dataset.lineKey === focus.key);
      const target = focus.quantity ? row?.querySelector('[data-kc-quantity]') : null;
      (target || this.panel).focus({ preventScroll: true });
    }
    async readCurrent(focus) {
      const url = new URL(this.dataset.cartUrl, location.origin);
      // Garder l’aperçu de thème si son identifiant est présent dans l’URL courante.
      const current = new URL(location.href);
      for (const key of ['preview_theme_id', '_fd', 'pb']) if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
      url.searchParams.set('section_id', this.sectionId);
      const revision = this.revision;
      const html = await this.request(url, { cache: 'no-store', headers: { Accept: 'text/html' } });
      if (this.isConnected && revision === this.revision) { this.applyHTML(html, focus); return true; }
      return false;
    }
    refresh() {
      if (!this.isConnected) return Promise.resolve(false);
      const run = async () => {
        if (!this.isConnected) return false;
        this.setBusy(true);
        this.querySelector('.kc-error').hidden = true;
        try { return await this.readCurrent(); }
        catch (_) { this.recoveryRequired = true; this.showError('Impossible d’actualiser le panier. Réessayez avant de continuer.'); return false; }
        finally { if (this.isConnected) this.setBusy(false); }
      };
      this.jobs = this.jobs.catch(() => {}).then(run);
      return this.jobs;
    }
    mutate(kind, payload, openAfter = false) {
      if (this.busy || this.recoveryRequired) return Promise.resolve(false);
      const focus = this.captureFocus();
      this.setBusy(true); ++this.revision;
      const run = async () => {
        if (!this.isConnected) return false;
        this.setBusy(true);
        this.querySelector('.kc-error').hidden = true;
        let accepted = false;
        try {
          const data = await this.request(this.endpoint(kind), {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ ...payload, sections: [this.sectionId], sections_url: this.dataset.cartUrl })
          });
          accepted = true;
          if (!this.isConnected) return false;
          try { this.applyHTML(data.sections?.[this.sectionId], focus); }
          catch (_) { if (!await this.readCurrent(focus)) throw new Error('Actualisation interrompue.'); }
          if (openAfter) this.open(this.activeElement);
          this.querySelector('[data-kc-status]').textContent = kind === 'add' ? 'Produit ajouté au panier.' : 'Panier mis à jour.';
          document.dispatchEvent(new CustomEvent('kaarz:cart:updated', { detail: { count: Number(this.querySelector('[data-kc-content]').dataset.count) } }));
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kaarz-cart', cartData: data })).catch(() => {});
          }
          return true;
        } catch (error) {
          if (!this.isConnected) return false;
          let recovered = false;
          try { recovered = await this.readCurrent(focus); } catch (_) { /* La lecture peut elle aussi échouer. */ }
          this.recoveryRequired = !recovered;
          this.showError(accepted ? 'Le panier a été modifié. Vérifiez son contenu avant de réessayer.' : error.confirmed ? error.message : 'Modification non confirmée. Vérifiez le panier avant de réessayer.');
          if (openAfter) this.open(this.activeElement);
          return false;
        } finally {
          if (this.isConnected) { this.setBusy(false); this.restoreFocus(focus); }
        }
      };
      this.jobs = this.jobs.catch(() => {}).then(run);
      return this.jobs;
    }
  }
  customElements.define('cart-drawer', KaarzCart);
})();
